import Wrapper from "../wrappers/TransactionHeader";

const TransactionHeader = () => {
    return <Wrapper>
        <h1>header</h1>
    </Wrapper>
}

export default TransactionHeader;